export const MANUAL_CHAIN_TUNING = Object.freeze({
  tickMs: 50,
  cargoCapacity: 5,
  initialChickenCount: 4,
  feedCapacity: 8,
  eggCapacity: 8,
  plotCount: 8,
  plotCooldownTicks: 60,
  unitActionTicks: 6,
  batchContactTicks: 4,
  batchPerUnitTicks: 2,
  tendTicks: 36,
  cashPerEgg: 8,
  penExtensionPrice: 24,
  routeTicks: 40,
  // Grok freer MPH pace: snappier first-yard walk (authority sim steps).
  directStepMicroWU: 175_000,
  diagonalStepMicroWU: 123_744,
} as const);

export const MANUAL_CHAIN_POINTS = Object.freeze({
  field: Object.freeze({ xMicroWU: -4_102_000, zMicroWU: -1_473_000 }),
  pen: Object.freeze({ xMicroWU: 1_000_000, zMicroWU: -1_473_000 }),
  market: Object.freeze({ xMicroWU: -1_551_000, zMicroWU: 2_945_000 }),
} as const);
